import { useMemo } from 'react'
import useIsMobile from './useIsMobile'
import useIsDesktop from './useIsDesktop'

export const useHeroImageByWidth = (imageName) => {
  const isMobile = useIsMobile(600) // Mobile breakpoint at 600px
  const isDesktop = useIsDesktop(1024) // Desktop breakpoint at 1024px

  return useMemo(() => {
    const urlPath = `https://assets-imgx.fubo.tv/marketing/lp/images/`

    if (imageName == 'default') {
      return null
    }
    let size = null
    if (isMobile) {
      size = 'sm'
    } else if (!isDesktop) {
      size = 'md' // Tablet (between 600px and 1024px)
    } else {
      size = 'lg' // Desktop (above 1024px)
    }

    return size
      ? `${urlPath}${imageName.includes('network-logos') ? 'posters' : 'welcome'}/${imageName}-${size}.png`
      : null
  }, [isMobile, isDesktop, imageName])
}
